import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import {
  normalizeToArray,
  isEmptySelection,
  stringifyWithArrays,
} from './utils/multiSelectUtils';

class SmsStatusSearchSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStatus: normalizeToArray(props.paramTools.params.sms_statuses),
    };
  }

  updateQuery = async (status) => {
    const normalized = normalizeToArray(status);
    this.setState({ selectedStatus: normalized });
    const { paramTools, inboxActions } = this.props;
    const { params } = paramTools;
    const { getRecords } = inboxActions;
    if (isEmptySelection(normalized)) {
      delete params.sms_statuses;
      params.page = 1;
    } else {
      params.sms_statuses = normalized;
      params.page = 1;
    }

    const query = stringifyWithArrays(params);
    await getRecords(query);
  }

  render() {
    const { hint } = this.props;
    const { selectedStatus } = this.state;
    const smsStatuses = [
      { value: 'in_progress', label: 'In Progress' },
      { value: 'sent', label: 'Sent' },
      { value: 'delivered', label: 'Delivered' },
      { value: 'delivery_failed', label: 'Failed' },
      { value: 'resent', label: 'Resent' },
    ];

    return (
      <div>
        <Select
          showSearch
          style={{ width: '220px', marginTop: 20 }}
          label="Reply Status"
          placeholder={hint}
          allowClear
          value={selectedStatus}
          mode="multiple"
          onChange={status => this.updateQuery(status)}
        >
          {smsStatuses.map(status => (
            <Select.Option key={status.value} value={status.value}>
              {status.label}
            </Select.Option>
          ))}
        </Select>
      </div>
    );
  }
}

SmsStatusSearchSettings.propTypes = {
  inboxActions: PropTypes.object.isRequired,
  paramTools: PropTypes.object.isRequired,
  hint: PropTypes.string,
};

SmsStatusSearchSettings.defaultProps = {
  hint: 'Search by SMS Status',
};

export default SmsStatusSearchSettings;
